<template>
    <a href="#" @click="sendClickEvent" title="" class="Trio-box-wrapper">
        <slot></slot>
    </a>
</template>

<script>
  export default {
    name: 'TrioLink',
    props: ['loading'],
    methods: {
      sendClickEvent() {
        this.$emit('clicked')
      }
    }
  }
</script>
